"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oAuthReducer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = require("lodash");

var _actions = require("./actions");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var unAuthenticatedState = {
  isLoggedIn: false,
  name: null,
  email: null,
  locale: null,
  id: null,
  permissionSetIds: null,
  permissions: [],
  tenant: null
};

var getDefaultState = function getDefaultState() {
  return _objectSpread({
    state: _constants.oAuthStates.LOADING
  }, unAuthenticatedState);
};

var oAuthReducer = function oAuthReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload,
      type = action.type;

  switch (type) {
    case _actions.SET_OAUTH_STATE:
      {
        if (!(0, _lodash.includes)(_constants.oAuthStates, payload.state)) {
          throw new Error('Unknown authentication state');
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          state: payload.state
        });
      }

    case _actions.USER_LOGOUT:
      {
        return _objectSpread(_objectSpread({}, state), unAuthenticatedState);
      }

    case _actions.SET_USER_LOGIN:
      {
        return _objectSpread(_objectSpread({}, state), payload.user);
      }

    default:
      return state;
  }
};

exports.oAuthReducer = oAuthReducer;
//# sourceMappingURL=oauth-reducer.js.map